/**
 * edj-size-guide.js
 * Modal natif <dialog> "Guide des tailles" — VAGUE 2 item 13
 *
 * Triggers :
 *   - clic sur tout élément [data-edj-open-size-guide]
 *
 * Fermeture :
 *   - clic sur [data-edj-close-size-guide]
 *   - clic backdrop (zone hors .edj-size-guide__inner)
 *   - touche Esc (gérée nativement par <dialog>)
 */
(function () {
  'use strict';

  function init() {
    const dialog = document.getElementById('edj-size-guide-dialog');
    if (!dialog) return;
    if (typeof dialog.showModal !== 'function') return; // navigateur sans support <dialog>

    document.addEventListener('click', e => {
      const opener = e.target.closest('[data-edj-open-size-guide]');
      if (opener) {
        e.preventDefault();
        if (!dialog.open) dialog.showModal();
        return;
      }

      if (e.target.closest('[data-edj-close-size-guide]')) {
        e.preventDefault();
        if (dialog.open) dialog.close();
        return;
      }
    });

    // Click backdrop = fermer
    dialog.addEventListener('click', e => {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
